import React from 'react';

const ConnectionStrength = ({ score, children }) => {
    // Ensure score is between 0 and 1
    const normalizedScore = Math.max(0, Math.min(1, score || 0));

    // Interpolate color from cool blue (0) to warm orange (1)
    const red = 255 + (255 - 255) * normalizedScore; // Stays 255
    const green = 165 + (100 - 165) * normalizedScore; // 165 (orange) -> 100 (blue-ish)
    const blue = 0 + (255 - 0) * (1 - normalizedScore); // 0 (orange) -> 255 (blue)

    const color = `rgb(${Math.round(red)}, ${Math.round(green)}, ${Math.round(blue)})`;

    // Determine shadow/glow intensity based on score
    const glowIntensity = normalizedScore > 0.7 ? 'lg' : (normalizedScore > 0.3 ? 'md' : 'sm');
    const shadowCss = {
        sm: `0 0 5px ${color}`,
        md: `0 0 10px ${color}`,
        lg: `0 0 15px ${color}, 0 0 5px ${color}`
    };

    return (
        <div className="relative">
            {children}
            <div
                className="absolute inset-0 rounded-full pointer-events-none"
                style={{
                    boxShadow: shadowCss[glowIntensity],
                    border: `2px solid ${color}`,
                    opacity: normalizedScore > 0.1 ? 1 : 0, // Only show for non-trivial strength
                    transition: 'all 0.3s ease-in-out',
                }}
            />
        </div>
    );
};

export default ConnectionStrength;
